module.exports = __webpack_public_path__ + "assets/img/0209.a2602747.svg";